/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2020 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
    'jquery',
    'domReady!'
], function ($) {
    "use strict";

    const navList = '.top-navigation__list',
        $navList = $(navList),
        navItems = '.top-navigation__item',
        $navItems = $(navItems),
        navItemHasChildren = '.top-navigation__item--parent, .top-navigation__inner-item--parent',
        $navItemHasChildren = $(navItemHasChildren),
        expandElement = '.dropdown-icon',
        subNav = '.top-navigation__inner-list',
        $subNav = $(subNav),
        moreItem = '.navigation__more',
        $moreItem = $(moreItem),
        moreButton = '.navigation__more-button',
        $moreButton = $(moreButton),
        moreNav = '.navigation__more__list',
        $moreNav = $(moreNav);

    // Make room in top menu for 'more' item
    if ($moreItem[0] != null) {
        $navList.css("margin-right", $moreItem[0].offsetWidth);
    }

    // Set class on submenu's that are set visible by CSS
    $navItemHasChildren.find(subNav).each(function () {
        const $currentSubNav = $(this);

        if($currentSubNav.css('display') == 'block') {
            $currentSubNav.addClass('initialy-visible');
        }
    });

    // Enable double click on parent item to expand sub navigation
    const clickTwice = (event, element) => {
        const $this = element;

        if (!$this.hasClass('tapped') && !$this.children('ul').hasClass('initialy-visible')) {
            event.preventDefault();
            $subNav.slideUp(100);
            $this.find(subNav).slideDown(200);

            if ($this.parent(navList).length) {
                $moreNav.slideUp(100);
                $moreItem.removeClass('active');
            }

            $navItemHasChildren.removeClass('tapped');
            $this.addClass('tapped');

            $this.find(expandElement).click(function (evt) {
                const $childSubNav = $this.children(subNav);

                if ($childSubNav.is(':visible')) {
                    $childSubNav.slideUp(100);
                    $this.removeClass('tapped');
                    evt.stopPropagation();
                } else {
                    $childSubNav.slideDown(200);
                    evt.stopPropagation();
                }
            });
        }
    };

    const calculateNav = () => {
        // Reset menu every time function fires
        let navWidth = 0,
            $navListWidth = void 0;

        if ($navList[0] != null) {
            $navListWidth = $navList[0].offsetWidth;
        }

        $moreItem.hide();
        $subNav.hide();
        $moreNav.hide();
        $('.hidden-item').appendTo($navList);
        $(navItems).removeClass('hidden-item visible-item');

        $(navItems).each(function () {
            const $navItem = $(this);

            // Calculate nav list width
            navWidth += $navItem[0].offsetWidth;

            // If calculated nav list width doesn't fit in available space, move the item to the more nav
            if ($navListWidth < navWidth) {
                // Show the more nav
                $moreItem.css({
                    display: 'block',
                    visibility: 'visible'
                });
                $navItem.addClass('hidden-item');
                $navItem.appendTo($moreNav);

                // Always bind clickTwice function to items with children in more nav
                $moreNav.find(navItemHasChildren).click(function (event) {
                    clickTwice(event, $(this));
                });
            } else {
                $navItem.addClass('visible-item');

                $navItems.removeClass('last');
                $navItem.addClass('last');

                // Bind clickTwice function to items in nav list when clicked on touchscreen to emulate hover
                $(navItemHasChildren).on('touchstart', function (event) {
                    clickTwice(event, $(this));
                });
            }
        });
    };

    // Reset more navigation
    const resetMore = () => {
        if ($moreItem.hasClass('active')) {
            $moreNav.slideUp(100);
            $moreItem.removeClass('active');
        }
    };

    $(function () {
        setTimeout(function () {
            calculateNav();
        }, 200)
    });

    // Cache window width
    let w = $(window).width();

    $(window).resize(function () {
        // Check if window width changes anf if so, fire calculateNav
        if (w != $(window).width()) {
            calculateNav();

            // Set window width to new width
            w = $(window).width();
        }
    });

    $navList.on('mouseenter', navItems, function () {
        // Reset subnav styles
        $(this).find(subNav).css('display', '');

        // Collapse more
        resetMore();
    });

    // Show more menu
    $moreButton.click(function () {
        $moreItem.toggleClass('active');
        $moreNav.slideToggle(200);
        $subNav.slideUp(100);
        $navItemHasChildren.removeClass('tapped');
    });

    // Hide more menu when clicked outside menu
    $(document).click(function(event) {
        if ($moreItem.hasClass('active') && !$(event.target).is($moreItem.find('*'))) {
            event.preventDefault();
            resetMore();
        }
    });
});
